import { ThemeProvider } from "@material-ui/core/styles";
import { muiThemeLight } from "./ui/theme";
import { Analytics } from "@vercel/analytics/react";
import { muiThemeDark } from "./ui/theme";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import { ClerkProvider } from "@clerk/clerk-react";
import { dark } from "@clerk/themes";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";


const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

export const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  const contextObj = useContext(AppContext);
  const { darkMode, sidebarOpen, rightSidebarOpen } = contextObj;

  const menu = "";
  const layout = "";

  return (
    <>
      <ThemeProvider theme={darkMode ? muiThemeDark : muiThemeLight}>
        <ClerkProvider
          publishableKey={PUBLISHABLE_KEY}
          afterSignOutUrl="/"
          appearance={{ baseTheme: darkMode ? dark : undefined }}
        >
          <DndProvider backend={HTML5Backend}>
            <div className={darkMode ? "dark" : "light"}>
              <div
                className={`
                antialiased relative font-inter 
                bg-white dark:bg-black
                text-black dark:text-white 
                overflow-x-hidden vertical 
                ${sidebarOpen ? "toggle-sidebar" : ""} 
                ${rightSidebarOpen ? "right-sidebar" : ""} 
                ${menu} ${layout} body min-h-screen overflow-y-hidden fixed top-0 left-0 right-0 bottom-0
              `}
              >
                {children}
              </div>
            </div>
          </DndProvider>
        </ClerkProvider>
      </ThemeProvider>
      <Analytics />
    </>
  );
};
